import { render, staticRenderFns } from "./AboutUser.vue?vue&type=template&id=583c769a&scoped=true&"
import script from "./AboutUser.vue?vue&type=script&lang=js&"
export * from "./AboutUser.vue?vue&type=script&lang=js&"
import style0 from "./AboutUser.vue?vue&type=style&index=0&id=583c769a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583c769a",
  null
  
)

export default component.exports